export default __webpack_public_path__ + "static/media/logoFootP.421bfd92.png";